import { Divider, Grid, Typography } from '@mui/material'

import AccordionOrderDevicesTable from '../../../../components/orders/accordion-devices-table'
import { formatAddress } from '../../../../utils/helpers'
import useSharedStyles from '../../../../utils/shared.styles'
import ClickToContact from '../../../people/components/click-to-contact'

export const ShipToInformation = ({ shipToAddress }: { shipToAddress: IOrderListItem['shipToAddress'] }) => {
  const sharedClasses = useSharedStyles
  const { address, code, country, locality, region, shipToName, shipToEmail, shipToCompany, shipToPhone } = shipToAddress || {
    address: '',
    code: '',
    country: '',
    locality: '',
    region: '',
    shipToName: '',
    shipToEmail: '',
    shipToCompany: '',
    shipToPhone: '',
  }

  return (
    <>
      <Typography variant="overline" sx={[sharedClasses.secondaryText, { align: 'baseline' }]}>
        Ship To
      </Typography>
      <Typography variant="body1">{shipToName}</Typography>
      {shipToEmail && <ClickToContact protocol="mailto" text={shipToEmail} />}
      {shipToPhone && <ClickToContact protocol="tel" text={shipToPhone} />}
      <br />
      <Typography variant="body1" className="fs-exclude">
        {shipToCompany}
      </Typography>
      <Typography variant="body1" className="fs-exclude">
        {formatAddress({ address, code, country, locality, region })}
      </Typography>
    </>
  )
}

const OrderAccordionDetails = ({ expandedDetails, shipToAddress }: { expandedDetails: IOrderItemExpanded; shipToAddress: IOrderListItem['shipToAddress'] }) => (
  <Grid
    container={true}
    sx={{
      gap: 2,
    }}
  >
    <Grid size={8.9}>
      <AccordionOrderDevicesTable expandedDetails={expandedDetails} />
    </Grid>
    <Grid size="auto">
      <Divider orientation="vertical" variant="middle" />
    </Grid>
    <Grid
      size="grow"
      sx={{
        paddingTop: 1,
      }}
    >
      <ShipToInformation shipToAddress={shipToAddress} />
    </Grid>
  </Grid>
)

export default OrderAccordionDetails
